// removed by extract-text-webpack-plugin
module.exports = {"new-order":"new-order","new-order-title":"new-order-title","new-order-sum-item":"new-order-sum-item","item-sum-icon":"item-sum-icon","item-title":"item-title","item-desc":"item-desc","wrap-item-desc":"wrap-item-desc","item-three-dot":"item-three-dot","item-one-line":"item-one-line","vtd-close":"vtd-close","new-order-item-desc":"new-order-item-desc","item-desc-icon":"item-desc-icon","new-order-view-all":"new-order-view-all","view-all-link":"view-all-link"};


//////////////////
// WEBPACK FOOTER
// ./components/my-business/sub-view/the-news/new-order/style.scss
// module id = ./components/my-business/sub-view/the-news/new-order/style.scss
// module chunks = 0